export const DocumentViewRawContentKey = "viewRawContent";

export const DocumentDeletionKey = "deleteDocumentOrTable";
